import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { FaChevronDown } from "react-icons/fa";
import axiosInstance from "../../axiosInstance";
import "../../styles/MultiSelectFilter.css";
import MultiSelectFilter from "../../CommonMultiSelectFilter/MultiSelectFilter";

const SalesInvoiceFilter = ({
    showFilters,
    setShowFilters,
    loadInvoiceOptions,
    loadProjectOptions,
    selectedInvoice,
    setSelectedInvoice,
    staticProject,
    setStaticProject,
    sapDocNumber,
    setSapDocNumber,
    fromDate,
    toDate,
    setFilterDateRange,
    appliedFilters,
    setAppliedFilters,
    fetchData,
    limit,
    searchTerm,
    activeTab,
    handleApply,
    handleClearFilters,
    setOpenByArrow,
    profitCenter,
    setProfitCenter,
    city,
    setCity,
    state,
    setState,
    zone,
    setZone,
    plantCode,
    setPlantCode,
    divisionType,
    setDivisionType
}) => {


    const zoneOptions = [
        { label: "East", value: "east" },
        { label: "West", value: "west" },
        { label: "South", value: "south" },
        { label: "North", value: "north" }
    ];

    const loadProfitCenterOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/projects/get_profit_centre",
                { params: { term: inputValue || '' } }
            );

            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadPlantCodeOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/plant_code/autosuggestion",
                { params: { term: inputValue || '' } }
            );

            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadCityOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/get_city", {
                params: { term: inputValue || "" }
            });

            return (res.data?.suggestionlist || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadStateOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/get_state", {
                params: { term: inputValue || "" }
            });

            return (res.data?.suggestionlist || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "40px",
            borderRadius: "12px",
            fontSize: "13px",
            width: "100%",
            borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
            boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
            "&:hover": { borderColor: "#454CF2" },
        }),
        container: (base) => ({ ...base, width: "100%" }),
        menu: (base) => ({ ...base, fontSize: "12px" }),
        menuList: (base) => ({
            ...base,
            maxHeight: "250px",
            overflowY: "auto"
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#F0F4F8',
            borderRadius: '4px',
            padding: '2px 6px',
            margin: '2px',
            maxWidth: '120px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#19324C',
            fontSize: '12px',
            fontWeight: 500
        }),
        valueContainer: (base) => ({
            ...base,
            maxHeight: "35px",
            height: "40px",
            overflowY: "auto",
            overflowX: "hidden",
            flexWrap: "wrap",
            alignItems: "center",
            paddingTop: "4px",
            paddingBottom: "4px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#19324C',
            ':hover': {
                backgroundColor: 'transparent',
                color: '#ff0000'
            }
        })
    };

    return (
        <div className="filter-scope"
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                padding: "15px",
                border: "1px solid #E5E5E5",
                borderRadius: "12px",
                margin: "20px",
            }}
        >
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p className="filter-header">Filter</p>

                {/* <div
                    onClick={() => setShowFilters(!showFilters)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        cursor: "pointer",
                        color: "#454CF2",
                        fontWeight: 600,
                        fontSize: "14px",
                        fontFamily: "'Work Sans', sans-serif",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#EDF3F9",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            transition: "transform 0.3s ease",
                            transform: showFilters ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                    >
                        <FaChevronDown
                            style={{
                                color: "#454CF2",
                                fontSize: "14px",
                                lineHeight: 1,
                            }}
                        />
                    </div>
                </div> */}
            </div>

            {showFilters && (
                <div className="filter-all" style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                    gap: "12px"
                }}>

                    {/* Invoice Number */}
                    <MultiSelectFilter
                        label="Invoice Number"
                        value={selectedInvoice || []}
                        onChange={(selected) => {
                            setSelectedInvoice(selected);
                            if (!selected || selected.length === 0) {
                                const updatedFilters = {
                                    ...appliedFilters,
                                    inv_number: null
                                };
                                setAppliedFilters(updatedFilters);
                                fetchData({
                                    skip: 0,
                                    limit,
                                    type: "sales",
                                    filter: updatedFilters,
                                    search: searchTerm
                                });
                            }
                        }}
                        loadOptions={loadInvoiceOptions}
                        placeholder="Select invoice no"
                        styles={customSelectStyles}
                    />

                    {/* Project */}
                    <MultiSelectFilter
                        label="Project"
                        value={staticProject || []}
                        onChange={(selected) => {
                            setStaticProject(selected);
                            if (!selected || selected.length === 0) {
                                const updatedFilters = {
                                    ...appliedFilters,
                                    project: null
                                };
                                setAppliedFilters(updatedFilters);
                                fetchData({
                                    skip: 0,
                                    limit,
                                    type: "sales",
                                    filter: updatedFilters,
                                    search: searchTerm
                                });
                            }
                        }}
                        loadOptions={loadProjectOptions}
                        placeholder="Select project"
                        styles={customSelectStyles}
                    />

                    {/* Plant Code */}
                    <MultiSelectFilter
                        label="Plant Code"
                        value={plantCode || []}
                        onChange={(selected) => {
                            setPlantCode(selected);
                            if (!selected || selected.length === 0) {
                                const updatedFilters = {
                                    ...appliedFilters,
                                    plant_code: null
                                };
                                setAppliedFilters(updatedFilters);
                                fetchData({
                                    skip: 0,
                                    limit,
                                    type: "sales",
                                    filter: updatedFilters,
                                    search: searchTerm
                                });
                            }
                        }}
                        loadOptions={loadPlantCodeOptions}
                        placeholder="Select Plant Code"
                        styles={customSelectStyles}
                    />

                    {/* SAP Doc */}
                    {(activeTab === "final invoice" || activeTab === "all") && (
                        <div className="filter-field">
                            <p className="filter-text">SAP Document Number</p>
                            <input
                                type="text"
                                className="filter-dropdown"
                                placeholder="Enter SAP doc no"
                                value={sapDocNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSapDocNumber(value);

                                    if (!value) {
                                        const updatedFilters = {
                                            ...appliedFilters,
                                            sap_doc_no: null
                                        };

                                        setAppliedFilters(updatedFilters);

                                        fetchData({
                                            skip: 0,
                                            limit,
                                            type: "sales",
                                            filter: updatedFilters,
                                            search: searchTerm
                                        });
                                    }
                                }}
                                style={{ margin: '0px', borderRadius: '12px' }}
                            />
                        </div>
                    )}

                    {/* Date */}
                    <div className="filter-field">
                        <p className="filter-text">Invoice Date Range</p>

                        <DatePicker
                            selectsRange
                            startDate={fromDate}
                            endDate={toDate}
                            isClearable
                            onChange={(update) => {
                                setFilterDateRange(update);

                                const [start, end] = update;

                                if (!start && !end) {
                                    const updatedFilters = {
                                        ...appliedFilters,
                                        from_date: null,
                                        to_date: null
                                    };

                                    setAppliedFilters(updatedFilters);

                                    fetchData({
                                        skip: 0,
                                        limit,
                                        type: "sales",
                                        filter: updatedFilters,
                                        search: searchTerm
                                    });
                                }
                            }}
                            placeholderText="Select date range"
                            className="filter-date-range-input"
                        />
                    </div>

                    {/* Profit Center */}
                    <MultiSelectFilter
                        label="Profit Center"
                        value={profitCenter || []}
                        onChange={(selected) => {
                            setProfitCenter(selected);
                            if (!selected || selected.length === 0) {
                                const updatedFilters = {
                                    ...appliedFilters,
                                    profit_centre: null
                                };
                                setAppliedFilters(updatedFilters);
                                fetchData({
                                    skip: 0,
                                    limit,
                                    type: "sales",
                                    filter: updatedFilters,
                                    search: searchTerm
                                });
                            }
                        }}
                        loadOptions={loadProfitCenterOptions}
                        placeholder="Select Profit Center"
                        styles={customSelectStyles}
                    />

                    {/* City */}
                    <MultiSelectFilter
                        label="City"
                        value={city || []}
                        onChange={(selected) => {
                            setCity(selected);
                            if (!selected || selected.length === 0) {
                                const updatedFilters = {
                                    ...appliedFilters,
                                    city: null
                                };
                                setAppliedFilters(updatedFilters);
                                fetchData({
                                    skip: 0,
                                    limit,
                                    type: "sales",
                                    filter: updatedFilters,
                                    search: searchTerm
                                });
                            }
                        }}
                        loadOptions={loadCityOptions}
                        placeholder="Select City"
                        styles={customSelectStyles}
                    />

                    {/* State */}
                    <MultiSelectFilter
                        label="State"
                        value={state || []}
                        onChange={(selected) => {
                            setState(selected);
                            if (!selected || selected.length === 0) {
                                const updatedFilters = {
                                    ...appliedFilters,
                                    state: null
                                };
                                setAppliedFilters(updatedFilters);
                                fetchData({
                                    skip: 0,
                                    limit,
                                    type: "sales",
                                    filter: updatedFilters,
                                    search: searchTerm
                                });
                            }
                        }}
                        loadOptions={loadStateOptions}
                        placeholder="Select State"
                        styles={customSelectStyles}
                    />

                    {/* Zone */}
                    <MultiSelectFilter
                        label="Zone"
                        value={zone || []}
                        onChange={(selected) => {
                            setZone(selected);
                            if (!selected || selected.length === 0) {
                                const updatedFilters = {
                                    ...appliedFilters,
                                    zones: null
                                };
                                setAppliedFilters(updatedFilters);
                                fetchData({
                                    skip: 0,
                                    limit,
                                    type: "sales",
                                    filter: updatedFilters,
                                    search: searchTerm
                                });
                            }
                        }}
                        options={zoneOptions}
                        isAsync={false}
                        placeholder="Select Zone"
                        styles={customSelectStyles}
                    />

                    {(activeTab === "all" || activeTab === "final invoice") && (
                        <>
                            <div className="filter-field">
                                <p className="filter-text">Division Type</p>
                                <select
                                    className="select-filter-dropdown"
                                    value={divisionType || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setDivisionType(value);

                                        if (!value) {
                                            const updatedFilters = {
                                                ...appliedFilters,
                                                division_type: null
                                            };

                                            setAppliedFilters(updatedFilters);

                                            fetchData({
                                                skip: 0,
                                                limit,
                                                type: "sales",
                                                filter: updatedFilters,
                                                search: searchTerm
                                            });
                                        }
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="scs">SCS</option>
                                    <option value="ff">FF</option>
                                </select>
                            </div>
                            <div className="filter-field"></div>
                            <div className="filter-field"></div>
                            <div className="filter-field"></div>
                            <div className="filter-field"></div>
                        </>
                    )}

                    {(activeTab === "draft" || activeTab === "submitted" || activeTab === "rejected" || activeTab === "sap pushed" || activeTab === "cancelled" || activeTab === "deleted") && (
                        <div className="filter-field">

                            <p className="filter-text">Division Type</p>
                            <select
                                className="select-filter-dropdown"
                                value={divisionType || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setDivisionType(value);

                                    if (!value) {
                                        const updatedFilters = {
                                            ...appliedFilters,
                                            division_type: null
                                        };

                                        setAppliedFilters(updatedFilters);

                                        fetchData({
                                            skip: 0,
                                            limit,
                                            type: "sales",
                                            filter: updatedFilters,
                                            search: searchTerm
                                        });
                                    }
                                }}

                            >
                                <option value="">Select</option>
                                <option value="scs">SCS</option>
                                <option value="ff">FF</option>
                            </select>
                        </div>
                    )}

                    {/* Buttons */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "5px",
                            // gridColumn:
                            //     activeTab === "all" || activeTab === "final invoice"
                            //         ? "span 4"
                            //         : undefined,
                            marginTop:
                                activeTab === "draft" ||
                                    activeTab === "submitted" ||
                                    activeTab === "rejected" ||
                                    activeTab === "sap pushed" ||
                                    activeTab === "cancelled" ||
                                    activeTab === "deleted"
                                    ? "25px"
                                    : "0px",
                        }}
                    >
                        <button className="jobs-cancel-btn" onClick={handleClearFilters}>
                            Reset
                        </button>
                        <button className="jobs-apply-btn" onClick={handleApply}>
                            Apply
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SalesInvoiceFilter;